export default __webpack_public_path__ + "static/kafka-7530d7f232026c3370e2021c8f8bf04b.png";